import fetch from "isomorphic-fetch";
import { devAPI } from "../util/urls";

export const getProjects = async () => {
  try {
    const url = `${devAPI}/projects`;

    let res = await fetch(url);
    const parsedRes = await res.json();

    if (!parsedRes) throw "failed to load projects";

    return parsedRes.organizations;
  } catch (e) {
    console.error(e);
    return null;
  }
};

// mdt etap
export const getEtapProject = async (project_id: string) => {
  try {
    const url = `${devAPI}/mdtEtaps/project/${project_id}`;

    let res = await fetch(url);
    const parsedRes = await res.json();

    if (!parsedRes) throw "failed to load projects";

    return parsedRes;
  } catch (e) {
    console.error(e);
    return null;
  }
};

// get etap project list data
export const getMdtEtaps = async () => {
  try {
    const url = `${devAPI}/mdtEtaps`;

    let res = await fetch(url);
    const parsedRes = await res.json();

    if (!parsedRes) throw "failed to load projects";

    return parsedRes;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getProjectsByList = async (id: string) => {
  try {
    const url = `${devAPI}/projects?list=${id}`;

    let res = await fetch(url);
    const parsedRes = await res.json();

    if (!parsedRes) throw "failed to load projects";

    return parsedRes.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const verifyProject = async (projectId: string) => {
  try {
    const url = `${devAPI}/projects/${projectId}/verify`;

    let res = await fetch(url);
    const parsedRes = await res.json();

    if (!parsedRes || res.status !== 200)
      throw `failed to verify project with id ${projectId}`;

    return parsedRes;
  } catch (e) {
    console.error(e);
    return null;
  }
};
